import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page74() {
  useEffect(() => {
    document.title = "Маяк — Страница 73"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page72" />
        <ForwardLink href="/page74" />
      </div>

      <p style={{ textAlign: "right" }}>73.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Вам можно доверять?
      </p>
      <p>СТАРИК садится.</p>
      <p>Гремит гром.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не надо мне ничего<br/>
        рассказывать.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Но...<br/>
        <br/>
        Все было не так, вот и все...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Мне не интересно.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Так я могу Вам доверять?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Никогда не любил, когда кому-то доверяли.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я знаю, чего Вы добиваетесь.<br/>
        Накачали меня пойлом--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Твоя нечистая совесть также<br/>
        скучна, как совесть любого<br/>
        другого.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Мы были на сплаве, слушайте...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Скучнее.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        На сплаве леса... и он начал<br/>
        браниться.<br/>
        <br/>
        Нет -- Я знаю, что Вы делаете...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ничего.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Слушайте, я имею в виду, слушайте, Том...<br/>
        даже не пытайтесь вытянуть из меня эту<br/>
        историю.
      </p>
      <p style={{ textAlign: "right" }}>73.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page72" />
        <ForwardLink href="/page74" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710634107/the-lighthouse-script/vdlnbuvc2f2muh6quxiy.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page74;
